<template>
  <v-dialog v-model="isOpen" max-width="360">
    <v-card>
      <v-card-title class="headline">
        {{ title }}
      </v-card-title>

      <v-card-text>
        {{ text }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text @click="$emit('onClose')">
          {{ $t('cancel') }}
        </v-btn>

        <v-btn
          text
          @click="
            isOpen = false;
            $store.dispatch('profile/logout');
          "
        >
          {{ $t('ok') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'LogoutDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: String,
    text: String,
  },

  data() {
    return {
      isOpen: this.value,
    };
  },
  watch: {
    isOpen(newValue, oldValue) {
      this.$emit('input', newValue);
    },
    value(newValue, oldValue) {
      this.isOpen = newValue;
    },
  },
};
</script>
